import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, makeStyles } from '@material-ui/core';
import DeleteButton from '../DeleteButton';
import DeleteDialog from '../DeleteDialog';
import FormBase from '../FormBase';
import PrimaryButton from '../PrimaryButton';
const useStyles = makeStyles(theme => ({
  actionButtons: {
    marginTop: theme.spacing(2)
  },
  button: {
    marginRight: theme.spacing(1)
  }
}));

const Form = ({
  cancelButtonText,
  children,
  onCancel,
  onDelete,
  submitButtonContent,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  return React.createElement(FormBase, props, formikProps => React.createElement(React.Fragment, null, children(formikProps), React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.actionButtons
  }, React.createElement(PrimaryButton, {
    type: "submit",
    disabled: formikProps.isSubmitting,
    className: classes.button
  }, submitButtonContent), !!onCancel && React.createElement(Button, {
    onClick: onCancel,
    disabled: formikProps.isSubmitting,
    className: classes.button
  }, cancelButtonText), !!onDelete && React.createElement(React.Fragment, null, React.createElement(DeleteButton, {
    disabled: formikProps.isSubmitting,
    onClick: e => {
      e.stopPropagation();
      setOpen(true);
    }
  }), React.createElement(DeleteDialog, {
    onDelete: onDelete,
    open: open,
    onClose: () => setOpen(false)
  })))));
};

Form.propTypes = {
  cancelButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  submitButtonContent: PropTypes.string
};
Form.defaultProps = {
  cancelButtonText: 'Cancel',
  onCancel: () => window.history.back(),
  // window.history.back cannot be assigned directly to onCancel https://stackoverflow.com/questions/46879422/window-history-back-illegal-invocation
  submitButtonContent: 'Submit'
};
export default Form;